import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverBreakEntity } from '../../domain/entities/DriverBreakEntity'

export class DriverBreakModel extends DriverBreakEntity {
  constructor(dataDto: DriverBreakEntity) {
    super()
    mapEntityProperties<DriverBreakEntity>(this, dataDto)
  }
}
